<template>
	<div class="service-locations-disclaimers-card">
		<dl>
			<dd>
				Estimate Disclaimer
			</dd>
			<dd>
				Repair Order Disclaimer
			</dd>
			<dd>
				Vehicle Inspection Disclaimer
			</dd>
			<dd>
				Work Order Disclaimer
			</dd>
		</dl>
	</div>
</template>

<script>
export default {
	name: 'ServiceLocationsDisclaimersCard'
};
</script>

<style lang="scss" scoped>
.service-locations-disclaimers-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
